module.exports = __webpack_public_path__ + "img/logo.3eb30ffd.png";